import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import Socials from './components/Socials'
import HeaderCarousel from './components/HeaderCarousel'
import Navigation from './components/Navigation'

import CardGroup from 'react-bootstrap/CardGroup';
import Card from 'react-bootstrap/Card';

import card_arch from './images/home/card_arch.jpg';
import card_birthday from './images/home/card_birthday.jpg';
import card_circle from './images/home/card_circle.jpg';
import card_xmas from './images/home/card_xmas.jpg';
import card_clothing from './images/home/card_clothing.jpg';
import card_tower from './images/home/card_tower.png';

import {Button} from "react-bootstrap";
import React from "react";

function App() {
  return (
    <div className="App">
        
        <Navigation/>

        <header className="App-header">
            <h1>Little B Crafts // Balloon displays // Personalised gifts</h1>
        
        <div className="container mt-2">
            <div className="row">
                <div className="col-md-4">
                    <img className="img-fluid" src={card_arch}/>
                </div>
                <div className="offset-md-2 col-md-6">
                    <p>Hello there and welcome to the website for Little B Crafts, we offer lots of different options for making your special occasion a little more personal. Balloon displays, gifts and wearable items all available with quality and speed in mind at all times. Get in touch if you have specific requirements and we can try to deliver on all of your needs.</p>
                    <p><Button variant="oversized" href="mailto:nicole@littlebcrafts.co.uk" target="_blank">Email</Button></p>

                </div>
            </div>
        </div>
        </header>
        <div className="container mt-2">
            <CardGroup>
                <Card className="" style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_clothing} />
                    <Card.Body>
                        <Card.Title>Personalised hampers</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Baby showers or gender reveals</Card.Subtitle>
                        <Card.Text>
                            The perfect gift for all baby related occasions or birthdays.
                            This is a Wooden Baby Hamper crate that comes with a clothing rail which you could hang clothes from or other gifts.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>

                <Card style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_xmas} />
                    <Card.Body>
                        <Card.Title>Seasonal gifts</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Valentines, Easter even Christmas</Card.Subtitle>
                        <Card.Text>
                            We offer a wide range of gifts that may be personalised for occassions such as Easter, Valentines or even Halloween.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>

                <Card style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_circle} />
                    <Card.Body>
                        <Card.Title>Balloon displays</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Balloon circles, welcome signs and banners available</Card.Subtitle>
                        <Card.Text>
                            Enhance your experience with personalised displays including balloons and welcome signs using our services.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>
            </CardGroup>
        </div>
        <div className="container mt-2">
            <CardGroup>
                <Card className="" style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_tower} />
                    <Card.Body>
                        <Card.Title>Towers of balloons or bespoke table pieces</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Whether you need something for a table or free standing</Card.Subtitle>
                        <Card.Text>
                            We can accomodate custom balloon towers with numbers for special birthdays or using bubble balloons.
                            Table pieces with balloons can elevate an occassion, we do also offer personalisation.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>

                <Card style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_birthday} />
                    <Card.Body>
                        <Card.Title>Birthday gifts</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Celebrate with those around you</Card.Subtitle>
                        <Card.Text>
                            Birthday parties are a fantastic occassion to celebrate so why not utilise balloon circles and arches at your event.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>

                <Card style={{ width: '18rem' }}>
                    <Card.Img variant="top" src={card_arch} />
                    <Card.Body>
                        <Card.Title>Friendly positive attitude always</Card.Title>
                        <Card.Subtitle className="mb-2 text-muted">Service with a smile</Card.Subtitle>
                        <Card.Text>
                            We can craft gifts or setup displays for your events with a cheery smile.
                        </Card.Text>
                        <Card.Link href="#">More info</Card.Link>
                    </Card.Body>
                </Card>
            </CardGroup>
        </div>
        <div className="container mt-2">
            <HeaderCarousel/>
        </div>
        <div className="mx-auto col-md-8">
        </div>
        
        <Socials/>
    </div>
  );
}

export default App;
